<template>
    <div class="">
        <div style="display: flex;justify-content: space-between;align-items:start;padding: 0  0 0 15px;">
            <el-button type="primary" style="width: 110px;padding: 10px 0;" @click="add">添加紧急联系人</el-button>
            <div>
                <div class="urgent" v-for="(item, index) in list" :key="index">
                    <el-form :model="item" label-suffix="：" :rules="rules" ref="ruleForm" :inline="true"
                        class="demo-ruleForm">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="姓名">
                                    <el-input v-model="item.name" placeholder="请输入紧急联系人姓名"
                                        style="width: 240px;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="电话" prop="phone">
                                    <el-input v-model="item.phone" placeholder="请输入紧急联系人电话"
                                        style="width: 240px;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="与本人关系">
                                    <div class="flex-box2">
                                        <div v-for="(item2, index2) in gxList" :key="index2"
                                            :class="item2.value == item.friendship ? 'sex-box active' : 'sex-box'"
                                            @click="item.friendship = item2.value">
                                            {{ item2.name }}
                                        </div>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <img
                            v-if="list.length > 1"
                            src="@/assets/imgs/shanchu@3x.svg"
                            alt=""
                            @click="del(item, index)"
                            class="urgent-del-btn firm-clickable"
                        />
                        <img
                            v-else
                            src="@/assets/imgs/shanchu-zhihui@3x.svg"
                            alt=""
                            class="urgent-del-btn urgent-del-btn--disabled"
                        />
                    </el-form>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            list: [
                {
                    name: '',
                    phone: '',
                    friendship: '',
                }
            ],
            gxList: [{
                name: '配偶',
                value: 0
            },
            {
                name: '父母',
                value: 1
            },
            {
                name: '子女',
                value: 2
            },
            {
                name: '其他',
                value: 3
            }],
            rules: {
                phone: [
                    { pattern: "^[1][3,4,5,6,7,8,9][0-9]{9}$", message: "请输入合法的手机号！", trigger: "blur" }
                ]
            }
        };
    },
    created() {
        this.list = this.normalizeEmergencyList(this.emergencyContacts);
    },
    props: {
        emergencyContacts: {}
    },
    watch: {
        'list': {
            handler(newVal) {
                this.$emit('getEmergencyContacts', newVal)
            },
            deep: true
        },
        emergencyContacts: {
            handler(newVal) {
                this.list = this.normalizeEmergencyList(newVal);
            },
            deep: true,
        },
    },
    methods: {
        normalizeEmergencyList(val) {
            if (Array.isArray(val) && val.length > 0) {
                return val;
            }
            return [
                {
                    name: "",
                    phone: "",
                    friendship: 0,
                },
            ];
        },
        add() {
            this.list.push({
                name: '',
                phone: '',
                friendship: 0,
            })
        },
        del(item, index) {
            if (this.list.length <= 1) {
                this.$tool.PromptBox("error", "至少保留一位紧急联系人！");
                return;
            }
            this.list.splice(index, 1);
        }
    }
}
</script>

<style lang="less" scoped>
.sex-box {
    width: 70px;
    height: 35px;
    border: 1px solid #409eff ;
    text-align: center;
    border-radius: 5px;
    line-height: 35px;
    background: #fff;
    color: #409eff ;
    margin-right: 20px;
    cursor: pointer;
}

.active {
    background: rgba(97, 144, 232, 0.27);

}

.urgent {
    width: 787px;
    margin-left: 20px;
    height: 140px;
    background: #FFFFFF;
    border: 1px dashed #409eff ;
    border-radius: 5px;
    padding: 15px 0 0 30px;
    box-sizing: border-box;
    margin-bottom: 20px;
    position: relative;
}
.urgent-del-btn {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
}
.urgent-del-btn--disabled {
    cursor: not-allowed;
}
/deep/.el-input__inner {
  border: 1px solid #409eff  !important ;
}
</style>